import { TaskCategory } from '../tasks/models';
import { IPackageDto, IProductDto } from './dtos';

export enum ProductType {
  Generic = 'GENERIC',
  Single = 'SINGLE',
  Additional = 'ADDITIONAL',
}

export enum ProductCategory {
  Case = 'CASE',
  Portrait = 'PORTRAIT',
  Shop = 'SHOP',
  Location = 'LOCATION',
  EndUserFee = 'ENDUSERFEE', // What is this?
  None = 'NONE',
}

export interface IProduct {
  _dto: IProductDto;
  id: string;
  quantity: number;
  name: string;
  description?: string;
  thumbnail?: string;
  price?: number;
  currency?: string;
  maxOrderAmount?: number;
  maxKvmSize?: number;
  tasks: { type: TaskCategory }[];
  unit: string;
  showAlert: boolean;
  itemNumber: string;
  config: string;
  variant?: string;
  individualProductName?: string;
}

export interface IProductChoice {
  products: IProduct[];
  packages?: IPackage[];
  group: string;
  minPrice: number;
  selectedProductId?: IProduct['id'] | IProduct['id'][];
  selectedPackageId?: IPackage['id'];
  price?: number;
}

export interface IPackage {
  _dto: IPackageDto;
  id: string;
  type: IPackageDto['grouping'];
  thumbnail: string;
  name: string;
  description?: string;
  basePrice: number;
  totalPrice: number;
  currency?: string;
  products: IProduct[];
  packages?: IPackage[];
  choices?: IProductChoice[];
  itemNumber: string;
  config: string;
  variant?: string;
}
